

     
// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "FullWidthSlider") {
    $this.FullWidthSliderActive();
  }else if($this.data('section') == "FeaturedCollection") {
    $this.find('.small_product_column3').FeaturedCollection();
  }else if($this.data('section') == "Hotdeal") {
   $this.HotdealActive();
  }else if($this.data('section') == "PopularCategories") {
    $this.find('.featured_column4').PopularCategories();
  }else if($this.data('section') == "PopularCategories2") {
    $this.find('.small_product_column3').PopularCategories2();
  }else if($this.data('section') == "TabWithProduct") {
   $this.TabWithProductActive();
  }else if($this.data('section') == "TabWithProduct_2") {
    $this.find('.product_column4').TabWithProduct_2();
  }else if($this.data('section') == "TabWithProduct3") {
   $this.TabWithProduct3Active();
  }else if($this.data('section') == "LatestBlog") {
   $this.LatestBlogActive();
  }else if($this.data('section') == "BrandLogo") {
   $this.BrandLogoActive();
  }else if($this.data('section') == "Testimonial") {
   $this.TestimonialActive();
  }else if($this.data('section') == "Instagram") {
        $this.InstagramSection();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "CollectionPage") {
    $this.CollectionPageActivation();
  }else if($this.data('section') == "RelatedProduct") {
   $this.RelatedProductActive();
  }else if($this.data('section') == "CustomCollection") {
   $this.CustomCollectionActive();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else if($this.data('section') == "single_product") {
    $this.single_product();
  }else{}   
}

       //  slider active js
$.fn.FullWidthSliderActive = function() {
  var $carousel = $('[data-owl-carousel]');
  var $OwlFullWidthSlider = $('.slider_area');

  if ($carousel.length) {
    $carousel.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
}; 
    
   
    // Featured Collection active js
$.fn.FeaturedCollection = function() {
  var $FeaturedCollectionVAR = this;
  $FeaturedCollectionVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',
  });
};

      
        //  Hot deal active js
$.fn.HotdealActive = function() {
  var $carousel2 = $('[data-owl-carousel]');

 var $OwlHotdeal = $('.product_column5');

  if ($carousel2.length) {
    $carousel2.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlHotdeal.owlCarousel();


};
    
       
    // Popular Categories active js
$.fn.PopularCategories = function() {
  var $PopularCategoriesVAR = this;
  $PopularCategoriesVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',
  });
};

        
       
    // Popular Categories active js
$.fn.PopularCategories2 = function() {
  var $PopularCategories2VAR = this;
  $PopularCategories2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',
  });
};

    
        //  Tab Product active js
$.fn.TabWithProductActive = function() {
  var $carouse3 = $('[data-owl-carousel]');

 var $OwlTabWithProduct = $('.product_column5');

  if ($carouse3.length) {
    $carouse3.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTabWithProduct.owlCarousel();


};
    
           
    //  Tab Product 2 active js
$.fn.TabWithProduct_2 = function() {
  var $TabWithProduct_2VAR = this;
  $TabWithProduct_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="ion-ios-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="ion-ios-arrow-right"></i></button>',
  });
};
        
        //  Tab Product 3 active js
$.fn.TabWithProduct3Active = function() {
  var $carouse5 = $('[data-owl-carousel]');

 var $OwlTabWithProduct3 = $('.product_column6');

  if ($carouse5.length) {
    $carouse5.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTabWithProduct3.owlCarousel();


};
    
         
    //  Latest Blog active js
$.fn.LatestBlogActive = function() {
  var $carouse6 = $('[data-owl-carousel]');

 var $OwlLatestBlog = $('.blog_column3');

  if ($carouse6.length) {
    $carouse6.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlLatestBlog.owlCarousel();


};
    
             
    //  Brand Logo active js
$.fn.BrandLogoActive = function() {
  var $carouse7 = $('[data-owl-carousel]');

 var $OwlBrandLogo = $('.brand_container');

  if ($carouse7.length) {
    $carouse7.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlBrandLogo.owlCarousel();


};
    
                 
    //  Testimonial active js
$.fn.TestimonialActive = function() {
  var $carouse8 = $('[data-owl-carousel]');

 var $OwlTestimonial = $('.testimonial_active');

  if ($carouse8.length) {
    $carouse8.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTestimonial.owlCarousel();


};
    
    
    
    
    // Instgram active js
    $.fn.InstagramSection = function(){
      var activation = this.find('[data-username]'),
          activeId = activation.attr('id'),
          clientUsername = activation.attr('data-username'),
          instagramHastag = activation.attr('data-hashtag'),
          ItemsLimit = activation.attr('data-limit'),
          imageSize = activation.attr('data-size'),
          instaslider = ".instagram-carousel";

      $.instagramFeed({
        'tag': instagramHastag,
        'username': clientUsername,
        'container': "#"+activeId,
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'styling': false,
        'items': ItemsLimit,
        'margin': 1,
        'image_size': imageSize
      });

 
    };


        //  Related Product active js
$.fn.RelatedProductActive = function() {
  var $carousel9 = $('[data-owl-carousel]');

 var $OwlRelatedProduct = $('.product_column4');

  if ($carousel9.length) {
    $carousel9.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlRelatedProduct.owlCarousel();


};


        //  Custom Collection active js
$.fn.CustomCollectionActive = function() {
  var $carousel10 = $('[data-owl-carousel]');

 var $OwlCustomCollection = $('.product_column4');

  if ($carousel10.length) {
    $carousel10.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlCustomCollection.owlCarousel();


};
    

$.fn.HeaderSectionsActivation = function() {
   
  



    /*---stickey menu---*/
    $(window).on('scroll',function() {    
           var scroll = $(window).scrollTop();
           if (scroll < 100) {
            $(".sticky-header").removeClass("sticky");
           }else{
            $(".sticky-header").addClass("sticky");
           }
    });
    


  
  
      
    /*---slide toggle activation---*/
   $('.mini_cart_wrapper > a').on('click', function(event){
        if($(window).width() < 991){
            $('.mini_cart').slideToggle('medium');
        }
    });
    
    /*categories slideToggle*/
    $(".categories_title").on("click", function() {
        $(this).toggleClass('active');
        $('.categories_menu_toggle').slideToggle('medium');
    }); 

      /*------addClass/removeClass categories-------*/
   $("#cat_toggle.has-sub > a").on("click", function() {
            $(this).removeAttr('href');
            $(this).toggleClass('open').next('.categorie_sub').toggleClass('open');
            $(this).parents().siblings().find('#cat_toggle.has-sub > a').removeClass('open');
    });
    
    
    
    /* ---------------------
	 Category menu
	--------------------- */
    
   
    function categorySubMenuToggle(){
        $('.categories_menu_toggle li.menu_item_children > a').on('click', function(){
        if($(window).width() < 991){
            $(this).removeAttr('href');
            var element = $(this).parent('li');
            if (element.hasClass('open')) {
                element.removeClass('open');
                element.find('li').removeClass('open');
                element.find('ul').slideUp();
            }
            else {
                element.addClass('open');
                element.children('ul').slideDown();
                element.siblings('li').children('ul').slideUp();
                element.siblings('li').removeClass('open');
                element.siblings('li').find('li').removeClass('open');
                element.siblings('li').find('ul').slideUp();
            }
        }
        });
        $('.categories_menu_toggle li.menu_item_children > a').append('<span class="expand"></span>');
    }
    categorySubMenuToggle();

  
      
   /*---canvas menu activation---*/
    $('.canvas_open').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').addClass('active')
    });
    
    $('.canvas_close,.off_canvars_overlay').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
    });
    

    
    /*---Off Canvas Menu---*/
    var $offcanvasNav = $('.offcanvas_main_menu'),
        $offcanvasNavSubMenu = $offcanvasNav.find('.sub-menu');
    $offcanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="fa fa-angle-down"></i></span>');
    
    $offcanvasNavSubMenu.slideUp();
    
    $offcanvasNav.on('click', 'li a, li .menu-expand', function(e) {
        var $this = $(this);
        if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length){
                $this.siblings('ul').slideUp('slow');
            }else {
                $this.closest('li').siblings('li').find('ul:visible').slideUp('slow');
                $this.siblings('ul').slideDown('slow');
            }
        }
        if( $this.is('a') || $this.is('span') || $this.attr('clas').match(/\b(menu-expand)\b/) ){
        	$this.parent().toggleClass('menu-open');
        }else if( $this.is('li') && $this.attr('class').match(/\b('menu-item-has-children')\b/) ){
        	$this.toggleClass('menu-open');
        }
    });
    

  
    $('.mega-menu-li-2').parent('ul').addClass('mega_menu_inner');
  $('.mega-menu-li').parent('ul').addClass('mega_menu_inner');
    $('.mega_menu_inner').parent('div').addClass('mega_menu');
   $('.mega_menu').parent('li').addClass('mega_items');
  $('.sub-menu-li').parent('ul').addClass('sub_menu');
  
  
};

$.fn.CollectionPageActivation = function() {


    /*---shop grid activation---*/
    $('.shop_toolbar_btn > button').on('click', function (e) {
        
		e.preventDefault();
        
        $('.shop_toolbar_btn > button').removeClass('active');
		$(this).addClass('active');
        
		var parentsDiv = $('.shop_wrapper');
		var viewMode = $(this).data('role');
        
        
		parentsDiv.removeClass('grid_3 grid_4 grid_5 grid_list').addClass(viewMode);

		if(viewMode == 'grid_3'){
			parentsDiv.children().addClass('col-lg-4 col-md-6 col-sm-6').removeClass('col-lg-3 col-cust-5 col-12');
            
		}

		if(viewMode == 'grid_4'){
			parentsDiv.children().addClass('col-lg-3 col-md-4 col-sm-6').removeClass('col-lg-4 col-cust-5 col-12');
		}
        
        if(viewMode == 'grid_list'){
			parentsDiv.children().addClass('col-12').removeClass('col-lg-3 col-lg-4 col-md-4 col-sm-6 col-cust-5');
		}
            
	});
  


      };

// Product Carousel
$.fn.single_product = function() {
    
      // prodct details slider active
  $('.product-large-slider').slick({
    fade: true,
    arrows: false,asNavFor: '.pro-nav'
  });
  // product details slider nav active
  $('.pro-nav').slick({
    slidesToShow: 4,
    asNavFor: '.product-large-slider',
    speed: 1000,
    centerPadding: 0,
    focusOnSelect: true,prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-right"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-left"></i></button>',responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      }
    }
    ]
  });
  
  document.addEventListener("DOMContentLoaded", function(event) {
  	$("img.lazyload").lazyload();
  });

};


  
  
(function($) {
  "use strict";

  jQuery(document).ready(function(){

    // All jQuery activation code paste here
    

    new WOW().init();  

    /*---background image---*/
	function dataBackgroundImage() {
		$('[data-bgimg]').each(function () {
			var bgImgUrl = $(this).data('bgimg');
			$(this).css({
				'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
			});
		});
    }
    
    $(window).on('load', function () {
        dataBackgroundImage();
    });


    $('.modal').on('shown.bs.modal', function (e) {
        $('.product_navactive').resize();
    })

    $('.product_navactive a').on('click',function(e){
      e.preventDefault();

      var $href = $(this).attr('href');

      $('.product_navactive a').removeClass('active');
      $(this).addClass('active');

      $('.product-details-large .tab-pane').removeClass('active show');
      $('.product-details-large '+ $href ).addClass('active show');

    })
    
    
    /*---  Accordion---*/
    $(".faequently-accordion").collapse({
        accordion:true,
        open: function() {
        this.slideDown(300);
      },
      close: function() {
        this.slideUp(300);
      }		
    });	  

   

    /*---  ScrollUp Active ---*/
    $.scrollUp({
        scrollText: '<i class="fa fa-angle-double-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });   
    
    /*---countdown activation---*/
		
	 $('[data-countdown]').each(function() {
		var $this = $(this), finalDate = $(this).data('countdown');
		$this.countdown(finalDate, function(event) {
		$this.html(event.strftime('<div class="countdown_area"><div class="single_countdown"><div class="countdown_number">%D</div><div class="countdown_title">Days</div></div><div class="single_countdown"><div class="countdown_number">%H</div><div class="countdown_title">Hours</div></div><div class="single_countdown"><div class="countdown_number">%M</div><div class="countdown_title">Mins</div></div><div class="single_countdown"><div class="countdown_number">%S</div><div class="countdown_title">Secs</div></div></div>'));     
               
       });
	});	


    
    /*js ripples activation*/
    $('.js-ripples').ripples({
		resolution: 512,
		dropRadius: 20,
		perturbance: 0.04
	});
    
    
    $('.qtybox .btnqty').on('click', function(){
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
            qty++;
          }else {
            if(qty > 1) {
              qty--;
            }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
        }); 
    
    /* Mobau (Agent D, 10.10.2026): Alt-Block entfernt, der auf Kollektions- und Produktseiten bei JEDEM change-Event
       eines beliebigen <input> die Seite neu lud, sobald [name="id"] nicht der Startvariante entsprach. Zweck war,
       nach einem Variantenwechsel im alten Theme die Liquid-Teile (Preis/Grundpreis aus gpn#-Tags) neu zu rendern.
       Die Produktseite (snippets/mobau-pdp-script.liquid) aktualisiert Preis, Grundpreis, Bestand, Bild und URL jetzt
       selbst; auf Kollektionen (dort ist product leer) löste der Block bei Filtern, Sortierung, Suche und den
       versteckten Variantenfeldern der Warenkorb-Knöpfe ungewollte Neuladungen aus. */
    
    
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    

  });
  

  if (window.location.href.indexOf("krinner-premium-xl") > -1) {
      window.location.href="https://mobaupro-uebach.de/products/krinner-ultra-grip-xl";  
  }


  if (window.location.href.indexOf("toyotomi-petroleum-plus") > -1) {
      window.location.href="https://mobaupro-uebach.de/collections/heizgerate-klein-elektro/products/20-l-flambiol%C2%AE-petroleum-heizol-in-kanistern";  
  }

  
})(jQuery);












